
import Glide from '@glidejs/glide';

(function() {

    (function () {
        const heroCarousel = document.querySelector('#heroCarousel');
        if (!heroCarousel) return false;
        new Glide(heroCarousel, {
            type: 'carousel',
            startAt: 0,
            perView: 3,
            autoplay: false,
            hoverpause: true,
            rewind: true,
            keyboard: true,
            breakpoints: {
                360: {
                    perView: 1,
                },
                480: {
                    perView: 1,
                },
                560: {
                    perView: 1,
                },
                768: {
                    perView: 2,
                },
                1024: {
                    perView: 2,
                },
                1280: {
                    perView: 3,
                }
            }
        }).mount();
    }());

}());


// WEBPACK FOOTER //
// ./src/js/module/hero-slider.js